"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripStyle = void 0;
var sanitizeHtml = require("sanitize-html");
exports.stripStyle = function (htmlStr) {
    // Remove unwanted tags and attribs
    return sanitizeHtml(htmlStr, {
        allowedTags: ['img', 'div', 'span', 'p', 'a', 'table', 'tr', 'td', 'thead', 'tbody', 'tfoot', 'th', 'li', 'ul', 'ol', 'strike', 'hr', 'br', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'string', 'em', 'pre', 'video', 'amp-img', 'amp-video', 'amp-instagram'],
        allowedAttributes: {
            video: ['src', 'poster'],
            img: ['src'],
            a: ['href'],
            'amp-video': ['src', 'poster', 'width', 'height', 'layout', 'controls'],
            'amp-img': ['src', 'width', 'height', 'layout'],
            'amp-instagram': ['width', 'height', 'layout', 'data-shortcode'],
            table: ['border', 'cellspacing', 'cellpadding', 'align'],
        },
        selfClosing: ['img', 'br', 'hr'],
        transformTags: {
            img: sanitizeHtml.simpleTransform('amp-img', { width: '300', height: '300', layout: 'responsive' }, true),
            video: sanitizeHtml.simpleTransform('amp-video', { width: '300', height: '300', layout: 'responsive', controls: 'controls' }, true),
            blockquote: function (t, attr) {
                return attr['data-instgrm-permalink'] ? {
                    tagName: 'amp-instagram',
                    attribs: {
                        'data-shortcode': attr['data-instgrm-permalink'].split('/p/')[1].slice(0, -1),
                        'data-captioned': '',
                        width: '1',
                        height: '1',
                        layout: 'responsive',
                    },
                } : ({
                    tagName: t,
                    attribs: attr,
                });
            },
        },
    });
};
